var map = {
	"./bn-in.svg": 5759,
	"./da.svg": 9224,
	"./de.svg": 9700,
	"./el.svg": 7802,
	"./en-us.svg": 709,
	"./es-es.svg": 6794,
	"./es-mx.svg": 5593,
	"./fi.svg": 682,
	"./fr-ca.svg": 3242,
	"./fr-fr.svg": 7534,
	"./id.svg": 902,
	"./it.svg": 9318,
	"./ja.svg": 8062,
	"./ko.svg": 4411,
	"./mr.svg": 6039,
	"./nl.svg": 3743,
	"./no.svg": 4716,
	"./pl.svg": 2233,
	"./pt-br.svg": 2586,
	"./pt-pt.svg": 2810,
	"./ru.svg": 5178,
	"./sv.svg": 7130,
	"./ta-in.svg": 7076,
	"./te.svg": 5172,
	"./tr.svg": 2123,
	"./uk.svg": 7845,
	"./vi.svg": 282,
	"./zh-cn.svg": 3599,
	"./zh-hk.svg": 5843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3943;